import * as R from 'ramda'

export const getBackDropMessageSelector = R.path(['message', 'backdrop'])
